import React, { useState } from "react";
import { Phone, Mail, Building2, Hash, CalendarDays, FileText } from "lucide-react";
import moment from "moment";
import UnitsCard from "../../../reusebale/uniCard";
import UnitDetailPopup from "../../../popup/isUnitDetail";

const InfoField = ({ icon: Icon, label, value }) => {
  if (!value) return null;
  return (
    <div className="flex items-start gap-2.5">
      <div className="mt-0.5">
        <Icon size={16} className="text-themeColor" />
      </div>
      <div>
        <p className="text-darkColor/40 font-popinsRegular text-xs uppercase tracking-wide">{label}</p>
        <p className="text-darkColor font-popinsSemiBold text-sm mt-0.5">{value}</p>
      </div>
    </div>
  );
};

const CompanyInfo = ({ data, leaseDetails }) => {
  const [showUnitDetail, setShowUnitDetail] = useState(false);

  const businessName = data?.companyInformation?.companyName || "N/A";
  const tenantName = leaseDetails?.tenantInfo
    ? `${leaseDetails.tenantInfo.firstName || ""} ${leaseDetails.tenantInfo.lastName || ""}`.trim()
    : "N/A";
  const mobile = leaseDetails?.tenantInfo?.cellNo || "N/A";
  const office = leaseDetails?.tenantInfo?.officeNo || "N/A";
  const email = leaseDetails?.tenantInfo?.email || "N/A";
  const unitNumber = leaseDetails?.unitInfo?.unitName || "N/A";
  const leaseStart = leaseDetails?.startDate
    ? moment(leaseDetails.startDate).format("MM/DD/YY")
    : "N/A";
  const leaseEnd = leaseDetails?.endDate
    ? moment(leaseDetails.endDate).format("MM/DD/YY")
    : "N/A";
  const additionalNotes = leaseDetails?.additionalNotes || "N/A";
  const propertyName = leaseDetails?.propertyInfo?.propertyName || "N/A";
  const tenantImage = data?.personalInformation?.profileImage?.url;
  const initials = `${leaseDetails?.tenantInfo?.firstName?.[0] || ""}${leaseDetails?.tenantInfo?.lastName?.[0] || ""}`.toUpperCase() || "T";

  return (
    <div className="bg-white rounded-xl p-5">
      {/* Property name heading */}
      <p className="text-darkColor font-popinsSemiBold text-xl leading-tight mb-4">
        {propertyName}
      </p>

      {/* Image + Tenant Info */}
      <div className="flex gap-5">
        {/* Left — Property Image */}
        <div className="flex-shrink-0 w-[140px] h-[140px] rounded-full overflow-hidden bg-gray-100">
          {tenantImage ? (
            <img
              src={tenantImage}
              alt={tenantName}
              className="w-full h-full object-cover"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center bg-themeColor/10">
              <span className="text-themeColor font-popinsSemiBold text-4xl">{initials}</span>
            </div>
          )}
        </div>

        {/* Right — Tenant Info */}
        <div className="flex-1">
          <p className="text-darkColor/40 font-popinsRegular text-xs uppercase tracking-widest mb-3">
            Tenant Profile
          </p>
          <div className="grid grid-cols-2 gap-x-8 gap-y-4">
            <InfoField icon={Building2} label="Business Name" value={businessName} />
            <InfoField icon={Phone} label="Tenant Mobile" value={mobile} />
            <InfoField icon={Building2} label="Tenant Name" value={tenantName} />
            <InfoField icon={Phone} label="Tenant Office" value={office} />
            <InfoField icon={Mail} label="Tenant Email" value={email} />
            <InfoField icon={Hash} label="Unit Number" value={unitNumber} />
            <InfoField icon={CalendarDays} label="Lease Start" value={leaseStart} />
            <InfoField icon={CalendarDays} label="Lease End" value={leaseEnd} />
            {additionalNotes && (
              <div className="col-span-2 pt-1 border-t border-gray-100">
                <InfoField icon={FileText} label="Additional Notes" value={additionalNotes} />
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Unit Info */}
      {leaseDetails?.unitInfo && (
        <div className="mt-4 pt-4 border-t border-gray-100">
          <UnitsCard
            isDeleteShow={false}
            occopied={true}
            onTrigger={() => setShowUnitDetail(true)}
            data={leaseDetails?.unitInfo}
            classes="w-full py-3 px-2 cursor-pointer"
          />
        </div>
      )}

      {showUnitDetail && (
        <UnitDetailPopup
          selectedUnit={leaseDetails?.unitInfo}
          onBack={() => setShowUnitDetail(false)}
        />
      )}
    </div>
  );
};

export default CompanyInfo;
